<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="medium" (click)="cancel()">Cancelar</ion-button>
    </ion-buttons>
    <ion-title>{{ titulo }} {{ tipo }}</ion-title>
    <ion-buttons slot="end">
      <ion-button [disabled]="!formValid" (click)="confirm()" [strong]="true"
        >Guardar</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  @if (tipo === 'hidrante') {
    <app-draw-hidrante
      (onSubmitComplete)="confirmComplete($event)"
      [att]="att"></app-draw-hidrante>
  }
  @if (tipo === 'toma') {
    <app-draw-toma
      (onSubmitComplete)="confirmComplete($event)"
      [att]="att"></app-draw-toma>
  }
  @if (tipo === 'pozo') {
    <app-draw-pozo
      (onSubmitComplete)="confirmComplete($event)"
      [att]="att"></app-draw-pozo>
  }
</ion-content>
